import { makeid } from 'utils/helpers/makeid';

import {
  additionalFollowUpItem,
  freeTextCommentsItem,
  isPatientCROorDNCItem,
  needEscalateItem,
  twoWaySyncInfoItem,
  uniqueDaysItem,
} from '../common';

import type { TFormItem } from '../../types';

export const weight: TFormItem[] = [
  {
    key: makeid(10),
    title: <p>What is the reason for weight monitoring for this patient?</p>,
    type: 'radio',
    required: false,
    name: 'weightReason',
    options: [
      {
        label: 'Congestive Heart Failure (CHF)',
        value: 'Congestive Heart Failure (CHF)',
        key: makeid(10),
      },
      { label: 'Renal Disease', value: 'Renal Disease', key: makeid(10) },
      {
        label: 'Weight Management',
        value: 'Weight Management',
        key: makeid(10),
      },
      {
        label: 'Other (please specify in free text field)',
        value: 'other',
        key: makeid(10),
      },
    ],
    items: [
      {
        key: makeid(10),
        type: 'textarea',
        name: 'weightReasonComment',
        title: null,
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        What was the patient’s average weight this week? <span>__ lbs</span>
      </p>
    ),
    type: 'input-number',
    required: false,
    name: 'weightAvg',
    validation: { min: 0 },
    items: [
      {
        type: 'radio',
        name: 'weightAvg30days',
        title: <p>Compared to the past 30 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
      {
        type: 'radio',
        name: 'weightAvg90days',
        title: <p>Compared to the past 90 days:</p>,
        key: makeid(10),
        options: [
          { label: 'Improved', value: 'improved', key: makeid(10) },
          { label: 'Worsened', value: 'worsened', key: makeid(10) },
          {
            label: 'No significant change',
            value: 'unchanged',
            key: makeid(10),
          },
        ],
      },
    ],
  },
  {
    key: makeid(10),
    title: (
      <p>
        Were all weight readings this week within the target range or expected
        trend for this patient?
      </p>
    ),
    type: 'radio',
    required: false,
    name: 'weightWithinRange',
    options: [
      { label: 'Yes', value: true, key: makeid(10) },
      { label: 'No', value: false, key: makeid(10) },
    ],
    items: [
      {
        type: 'textarea',
        name: 'weightWithinRangeComment',
        title: null,
        key: makeid(10),
      },
    ],
  },
  { ...uniqueDaysItem('weight') },
  { ...twoWaySyncInfoItem },
  { ...isPatientCROorDNCItem },
  { ...additionalFollowUpItem },
  { ...needEscalateItem },
  { ...freeTextCommentsItem },
];
